import React, { Component } from 'react';

class Overview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tab: [
                {
                    id: 1,
                    text: 'At K.Lizz Classic Hardware, we are committed to providing Nairobi with the highest quality building materials at competitive prices. Our extensive inventory and knowledgeable staff ensure you get exactly what you need for your construction or renovation project.',
                    item: [
                        {
                            idx: 1,
                            content: 'Premium quality plywood, MDF boards, and blockboards from trusted manufacturers',
                        },
                        {
                            idx: 2,
                            content: 'Wide selection of doors including flash doors, mahogany doors, and custom designs',
                        },
                        {
                            idx: 3,
                            content: 'Complete range of hardware supplies, paints, tools, and construction materials',
                        }
                    ]
                },
                {
                    id: 2,
                    text: 'We understand that every construction project is unique. That\'s why we maintain large stock levels and offer expert consultation to help you select the right materials and calculate accurate quantities for your specific needs.',
                    item: [
                        {
                            idx: 1,
                            content: 'Ready stock available - no waiting times for your urgent projects',
                        },
                        {
                            idx: 2,
                            content: 'Competitive pricing without compromising on material quality',
                        },
                        {
                            idx: 3,
                            content: 'Delivery services available throughout Nairobi and surrounding areas',
                        }
                    ]
                },
                {
                    id: 3,
                    text: 'Our reputation is built on the principle "We Flow With Qualities." Every product we stock meets our strict quality standards, ensuring your projects are built on solid foundations with materials you can trust.',
                    item: [
                        {
                            idx: 1,
                            content: 'Established supplier with years of experience in the Nairobi market',
                        },
                        {
                            idx: 2,
                            content: 'Professional team ready to assist with material selection and technical advice',
                        },
                        {
                            idx: 3,
                            content: 'Monday to Saturday service - we\'re here when you need us',
                        }
                    ]
                }

            ]
        }
    }
    
    render() {
        return (
            <div className="col-md-6">
                <div className="themesflat-content-box clearfix" data-margin="0 18px 0 0" data-mobilemargin="0 0 0 0">
                    <div className="themesflat-headings style-1 clearfix">
                        <h2 className="heading">WHY CHOOSE US</h2>
                        <div className="sep has-width w80 accent-bg margin-top-11 clearfix" />
                    </div>
                    <div className="themesflat-spacer clearfix" data-desktop={38} data-mobile={35} data-smobile={35} />
                    <div className="themesflat-tabs style-1 clearfix">
                        <ul className="tab-title clearfix">
                            <li className="item-title active">
                                <span className="inner">Quality Products</span>
                            </li>
                            <li className="item-title">
                                <span className="inner">Customer Service</span>
                            </li>
                            <li className="item-title">
                                <span className="inner">Our Promise</span>
                            </li>
                        </ul>
                        <div className="tab-content-wrap clearfix">
                            {
                                this.state.tab.map(data => (
                                    <div className="tab-content" key={data.id}>
                                        <div className="item-content">
                                            <p>{data.text}</p>
                                            {
                                                data.item.map(index => (
                                                    <div className="themesflat-list has-icon style-1 icon-left ofset-padding-32 clearfix" key={index.idx}>
                                                        <div className="inner">
                                                            <span className="item">
                                                                <span className="icon"><i className="fa fa-check-square" /></span>
                                                                <span className="text">{index.content}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                        </div>{/* /.tab-content-wrap */}
                    </div>{/* /.themesflat-tabs */}
                </div>{/* /.themesflat-content-box */}
            </div>
        );
    }
}

export default Overview;